/**
 * Comparison Rate Disclaimer — VERBATIM legal text supplied by Greystone's
 * lawyers (NCCP consumer-credit advertising requirement). The wording must not
 * be changed. Rendered as a collapsible so it satisfies the disclosure without
 * crowding the rates box. Shown wherever advertised rates appear (home hero +
 * calculator), via RatesStrip.
 */
const EXCLUSIONS = [
  'The use of account features such as early repayments and offset accounts which vary widely among loans and can reduce the cost of a loan significantly.',
  'Cost savings such as fee waivers or special rate discounts.',
  'Fees and charges associated with loan options or events that may or may not be used by the borrower, such as early repayment or redraw fees.',
  'Lenders Mortgage Insurance (LMI) which may be required to secure the loan and can increase the cost of the loan.',
  'Government charges such as stamp duty or mortgage registration fees.',
  'Fees and charges which aren’t available at the time the comparison rate is provided.',
]

export default function ComparisonRateDisclaimer() {
  return (
    <details className="mt-4 group border-t border-[#E8E8E2] pt-3">
      <summary className="cursor-pointer list-none flex items-center justify-between gap-2 text-[11px] font-semibold uppercase tracking-wide text-gs-text-muted hover:text-ink">
        <span>Comparison rate disclaimer</span>
        <span aria-hidden="true" className="transition-transform group-open:rotate-180 text-gs-text-muted">⌄</span>
      </summary>
      <div className="mt-3 space-y-2 text-[11px] leading-relaxed text-gs-text-muted">
        <p className="font-semibold text-gs-text-soft">Comparison Rates</p>
        <p>
          The comparison rate is based on a loan of $150,000 over a term of 25 years at an LVR of 70%. WARNING: This
          comparison rate is true only for the example given and may not include all fees and charges.
          Different terms, fees or other loan amounts might result in a different comparison rate. For
          variable interest-only loans, comparison rates are based on an initial 5-year Interest Only
          period. For fixed Interest Only loans, comparison rates are based on an initial Interest Only
          period equal in length to the fixed period. During an Interest Only period, your Interest Only
          payments will not reduce your loan balance. This may mean you pay more interest over the life
          of the loan.
        </p>
        <p>Monthly Repayment and Comparison Rate* calculations do not include:</p>
        <ul className="list-disc pl-4 space-y-1">
          {EXCLUSIONS.map((line) => (
            <li key={line}>{line}</li>
          ))}
        </ul>
      </div>
    </details>
  )
}
